<template>
    <div v-show="showPagination" id="pagination" class="row">
        <div style="margin: 0 auto;">
            <nav aria-label="Page navigation example">
                <ul class="pagination">
                    <li class="page-item arrow previous">
                        <a class="btn btn-wrap-arrow" href="javascript://prev" aria-label="Previous" v-on:click="loadPrevPageScroll">
                            <div class="arrow left"></div>
                        </a>
                    </li>

                    <li class="page-item"  v-for="(item, index) in this.pagination.listPage" :key="index">
                        <a :class="[item == pagination.page ? 'btn btn-wrap-pagination' : 'btn btn-outline-pagination']" href="javascript://page" v-on:click="loadPageScroll(item)">{{ item }}</a>
                    </li>

                    <li class="page-item arrow next">
                        <a class="btn btn-wrap-arrow" href="javascript://next" aria-label="Next"  v-on:click="loadNextPageScroll">
                            <div class="arrow right"></div>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
import namespace from '../../vuex/namespace'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'Pagination',
  data: function () {
    return {
      page: 1
    }
  },
  computed: {
    ...mapState(namespace.ORDERS, [
      'showPagination',
      'quantityPage',
      'currentPage',
      'pagination'
    ]),
    ...mapGetters(namespace.ORDERS, [
      'getPage'
    ]),
    ...mapState(namespace.ROUTE, [
      'params'
    ])
  },
  methods: {
    ...mapActions(namespace.ORDERS, [
      'loadNextPage',
      'loadPrevPage',
      'setPage'
    ]),
    loadNextPageScroll () {
      this.scroll()
      this.loadNextPage()
    },
    loadPrevPageScroll () {
      this.scroll()
      this.loadPrevPage()
    },
    loadPageScroll (page) {
      this.scroll()
      this.setPage(page)
    },
    scroll () {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped lang="scss">
    #pagination {
        margin: 50px 0 20px;
        ul {
            li {
                margin: 0 4px;
                .btn {
                    line-height: 18px;
                }
                .btn.btn-wrap-pagination,
                .btn.btn-outline-pagination{
                    width: 40px;
                    padding-left: 5px;
                    padding-right: 5px;
                }
                .btn.btn-wrap-arrow{
                    line-height: 14px;
                }
            }
            li.arrow.previous {
                padding-right: 15px;
            }
            li.arrow.next {
                padding-left: 15px;
            }
        }
    }
</style>
